export default __webpack_public_path__ + "static/media/Logo-ECDConnect-white.9130f9b8.svg";